import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/VandanaPai.jpg";
const icon2 = "https://winpeforum.com/assets/elements/Nishanth-Ravindran.png";
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/wob/4dec2025/1.png";
const I2 = "https://www.winpeforum.com/assets/wob/4dec2025/2.png";
const I3 = "https://www.winpeforum.com/assets/wob/4dec2025/3.png";
const I4 = "https://www.winpeforum.com/assets/wob/4dec2025/4.png";
const I5 = "https://www.winpeforum.com/assets/wob/4dec2025/5.png";
const I6 = "https://www.winpeforum.com/assets/wob/4dec2025/6.png";
const I7 = "https://www.winpeforum.com/assets/wob/4dec2025/7.png";
const I8 = "https://www.winpeforum.com/assets/wob/4dec2025/8.png";
const I9 = "https://www.winpeforum.com/assets/wob/4dec2025/9.png";
const I10 = "https://www.winpeforum.com/assets/wob/4dec2025/10.png";
const I11 = "https://www.winpeforum.com/assets/wob/4dec2025/11.png";
const I12 = "https://www.winpeforum.com/assets/wob/4dec2025/12.png";
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/1.png";
const II2 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/2.png";
const II3 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/3.png";
const II4 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/4.png";
const II5 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/5.png";
const II6 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/6.png";
const II7 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/7.png";
const II8 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/8.png";
const II9 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/9.png";
const II10 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/10.png";
const II11 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/11.png";
const II12 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/12.png"; 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
        {
          imgUrl: icon2,
          desc: ` `,
          name: "Nishanth Ravindran",
          post: `<div>Partner<br/>AZB & Partners




          </div>`,
        },
          
            
      
      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   

        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
        { id:23, ImgSrc: I7, ImgSrc1: II7,},   
      
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   

        { id:22, ImgSrc: I9, ImgSrc1: II9,},   
        { id:19, ImgSrc: I10, ImgSrc1: II10,},  
        { id:35, ImgSrc: I11, ImgSrc1: II11,},   
        { id:34, ImgSrc: I12, ImgSrc1: II12,},  
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
         <Meta
          title="Women on Boards"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Winpe’s Women on Boards initiative hosted another exceptional session marked by profound insights, engaging discussions, and inspiring connections. We are pleased to report that the session received outstanding evaluations—100% of participants acknowledged significant knowledge gains, and our speakers were rated exceptionally well at 4.5."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">        Winpe’s Women on Boards<br/>
                          Topic: Decoding India’s Labour Codes-Boardroom Perspective
  </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                 <span> 
      September 4th, 2026 (04:00 - 05:00 PM IST)<br/>
   Format- Virtual (Zoom)
</span>
                </div>
              </div>
              <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
        Winpe’s Women on Boards initiative is reshaping board leadership by advancing high-caliber,
board-ready women. Through partnerships with progressive companies and targeted
board-prep programs, it offers curated talent and strategic engagement models that
strengthen governance and support DEI goals.<br/><br/>
The recent session on “Decoding India’s Labour Codes – Boardroom Perspective,” led by
Nishanth Ravindran, AZB & Partners, offered senior women leaders a concise and insightful
view of the four Labour Codes and their implications for governance, workforce strategy,
financial exposure, and board oversight.<br/><br/>
With the Labour Codes effective from November 21, 2025, and the Central Rules notified on
May 8, 2026, the session focused on the key shifts boards need to understand as organisations
navigate implementation.<br/><br/>
The session received excellent feedback from participants, who appreciated the practical
insights, clarity of the discussion, and its strong relevance to board-level decision-making.
<br/><br/>
Catch the full recording <a style={{textDecoration:'underline', color:'blue'}} href="youtu.be/vrWFqS21-C4">here</a><br/><br/>
Join our Women on Boards community to access curated board opportunities and stay
informed on upcoming sessions, insights, and engagements through our WhatsApp group.
<br/><br/>

👉 <a style={{textDecoration:'underline', color:'blue'}}  href="https://tally.so/r/wv9OJX">Join our peer community</a>    &nbsp;&nbsp;&nbsp;&nbsp;👉          <a style={{textDecoration:'underline', color:'blue'}}  href="https://chat.whatsapp.com/CYRLOvnGjyeJgd45frXkwf?s=cl&p=a&ilr=1">Join the WhatsApp Group</a>
<br/> <br/>


<br/> 
  


<h3><b>Session Takeaways: </b></h3>
 
<ul>
   
    
<li><b>Board Accountability:</b> Labour compliance is increasingly a board-level governance and
risk issue, with potential liability extending to directors in certain circumstances.
</li> 

<li><b>Wage Definition:</b> The revised definition of “wages” has direct implications for gratuity,
leave encashment, and retrenchment liabilities, making it a key financial consideration
for boards.

</li> 

<li><b>Immediate Readiness:</b> Organisations need to assess their compensation structures,
employee benefit liabilities and processes, including the requirement for full-and-final
settlement within two working days.
</li> 

<li><b>Defensible Compliance Frameworks:</b> Compliance must be demonstrable through comprehensive documentation, embedded controls, regular audits, and strong audit trails to withstand regulatory scrutiny. 
</li> 

<li><b>Workforce Strategy:</b> Changes relating to fixed-term employment, retrenchment and
contract labour have implications for workforce planning, restructuring and operating
models.

</li> 

<li><b>Future of Work:</b> The inclusion of gig and platform workers within the social-security
framework signals an evolving employment landscape that boards need to factor into
long-term workforce strategy.


</li> 
<li><b>Employee Governance:</b> Grievance redressal, workplace safety, working hours and
employee welfare are increasingly important elements of responsible workforce
governance.


</li> 
<li><b>Gender & Inclusion:</b> The Codes reinforce the need for equitable employment practices,
providing boards an opportunity to strengthen their focus on gender equity, workplace
participation and inclusive workforce policies.


</li> 
<li><b>State-Level Readiness:</b> While substantive provisions are actionable, state-level rules
remain an evolving area. Organisations operating across multiple states need to maintain
regulatory readiness and monitor developments closely.


</li> 
 

 
<li><b>Risk & Compliance:</b> Boards should seek clear management assurance on compliance
readiness, documentation, controls and emerging liabilities.


</li> 
</ul>


<h3><b>The Boardroom Perspective</b></h3>
 
<p>The Labour Codes represent more than a regulatory change. They have strategic implications
for people, cost, risk and business resilience. For senior women leaders, understanding these
shifts strengthens their ability to challenge management, oversee workforce risk, and
contribute meaningfully to board-level decision-making.</p>
    <div className="row"> 
                          

                  <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Faculty</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '70%', margin:'0' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=3) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 



 

              </div>
              
             
            
  <br/> 
   
<div class="container">
<br/>
 
 
 </div>
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/WOBDecodingIndiasLabourCodes/index.js